import React from 'react';
import { ArrowLeft, Save, Printer, Send } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

/**
 * Document Header Bar Actions
 * Reusable action buttons for document pages
 */
const DocumentHeaderBar = ({
  backPath,
  onSave,
  onPrint,
  onFinalize,
  saveLoading = false,
  saveLabel = 'Save Draft',
  finalizeLabel = 'Finalize',
  showFinalize = true,
  showPrint = true
}) => {
  const navigate = useNavigate();

  return (
    <>
      {/* Desktop Actions */}
      <div className="hidden md:flex items-center gap-2">
        <Button
          variant="ghost"
          size="sm"
          onClick={() => navigate(backPath)}
          className="hidden lg:flex"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>
        
        <Button
          variant="outline"
          size="sm"
          onClick={onSave}
          disabled={saveLoading}
          className="border-2 border-blue-300 hover:bg-blue-50"
        >
          <Save className="w-4 h-4 mr-2" />
          {saveLoading ? 'Saving...' : saveLabel}
        </Button>

        {showPrint && (
          <Button
            variant="outline"
            size="sm"
            onClick={onPrint}
            className="border-2 border-purple-300 hover:bg-purple-50"
          >
            <Printer className="w-4 h-4 mr-2" />
            Print
          </Button>
        )}

        {showFinalize && onFinalize && (
          <Button
            size="sm"
            onClick={onFinalize}
            className="bg-gradient-to-r from-blue-600 to-purple-600 text-white hover:from-blue-700 hover:to-purple-700"
          >
            <Send className="w-4 h-4 mr-2" />
            {finalizeLabel}
          </Button>
        )}
      </div>

      {/* Mobile Fixed Bottom Action Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-white border-t border-gray-200 shadow-2xl p-3">
        <div className="grid grid-cols-2 gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={onSave}
            disabled={saveLoading}
            className="border-2 border-blue-300"
          >
            <Save className="w-3 h-3 mr-1" />
            {saveLoading ? 'Saving...' : 'Save'}
          </Button>
          
          {showFinalize && onFinalize && (
            <Button
              size="sm"
              onClick={onFinalize}
              className="bg-gradient-to-r from-blue-600 to-purple-600 text-white"
            >
              <Send className="w-3 h-3 mr-1" />
              Send
            </Button>
          )}
          
          {showPrint && (
            <Button
              variant="outline"
              size="sm"
              onClick={onPrint}
              className="border-2 border-purple-300"
            >
              <Printer className="w-3 h-3 mr-1" />
              Print
            </Button>
          )}
          
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigate(backPath)}
          >
            Cancel
          </Button>
        </div>
      </div>
    </>
  );
};

export default DocumentHeaderBar;